import { render, staticRenderFns } from "./PrestigeHeaderText.vue?vue&type=template&id=22633648&scoped=true&"
import script from "./PrestigeHeaderText.vue?vue&type=script&lang=js&"
export * from "./PrestigeHeaderText.vue?vue&type=script&lang=js&"
import style0 from "./PrestigeHeaderText.vue?vue&type=style&index=0&id=22633648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22633648",
  null
  
)

export default component.exports